import { Component, Input, OnInit } from '@angular/core';
import { GlobalConstants } from 'functions/src/shared/global-constants';
import { MyAgentsStatService } from 'src/services/stat/stat.service';

@Component({
  selector: 'app-agents-stats',
  templateUrl: './agents-stats.component.html',
  styleUrls: ['./agents-stats.component.scss']
})
export class AgentsStatsComponent {

  public GLOBAL = new GlobalConstants();

  constructor(public myAgentsStatService: MyAgentsStatService) { }

  @Input() year: boolean = false;
  public date = new Date();


}
